import React from "react";
import { motion } from "framer-motion";
import { CONSTANTS } from "../data";
import { Calendar, Star, Dices } from "lucide-react";

interface DailyBlendBannerProps {
  dailyBlend: any;
  seededSession: boolean;
}

const DailyBlendBanner: React.FC<DailyBlendBannerProps> = ({
  dailyBlend,
  seededSession,
}) => {
  const isDailyBlendActive = dailyBlend.trio && dailyBlend.trio.length > 0 && !dailyBlend.completed;
  const remainingTime = dailyBlend.buffActive ? Math.max(0, dailyBlend.buffExpiry - Date.now()) : 0;
  const isBuffActive = dailyBlend.buffActive && remainingTime > 0;

  if (seededSession) {
    return (
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "auto", opacity: 1 }}
        className="bg-black/20 text-white text-center py-2 font-semibold text-sm overflow-hidden flex items-center justify-center gap-2"
      >
        <Dices size={16} />
        <span>Practice Seed—No Daily Rewards</span>
      </motion.div>
    );
  }

  if (!isBuffActive && !isDailyBlendActive) {
    return null;
  }

  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: "auto", opacity: 1 }}
      className="bg-black/20 text-white text-center py-2 font-semibold text-sm overflow-hidden flex items-center justify-center gap-2"
    >
      {isBuffActive ? (
        <>
          <Star size={16} className="animate-pulse" />
          <span className="animate-pulse">
            Daily Buff Active! +25% Tips ({Math.ceil(remainingTime / 1000)}s)
          </span>
        </>
      ) : isDailyBlendActive ? (
        <>
          <Calendar size={16} />
          <span>
            Daily Blend:{" "}
            {dailyBlend.trio
              .map(
                (id: string) =>
                  CONSTANTS.ITEMS[id]?.name ||
                  CONSTANTS.RECIPES[
                    Object.keys(CONSTANTS.RECIPES).find(
                      (k) => CONSTANTS.RECIPES[k].result.id === id
                    ) || ""
                  ]?.result.name ||
                  id
              )
              .join(", ")}{" "}
            ({dailyBlend.progress.length}/3)
          </span>
        </>
      ) : null}
    </motion.div>
  );
};

export default DailyBlendBanner;
